module.exports = __webpack_public_path__ + "static/img/down3.033253d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/down3.png
// module id = hg5J
// module chunks = 1